
import { Component, Vue } from 'types-vue';
import CppService from '../Services/CCP'

@Component
export default class CcpMixin extends Vue {

  protected connect: any  = null

  initCCP(containerElement: HTMLElement): void {
    CppService.init(containerElement)
  }
}